import React from 'react';
import InterfaceInfo from './components/InterfaceInfo';

const InterfacesDetailView = () => <InterfaceInfo />;

export default InterfacesDetailView;
